const $ = jQuery.noConflict()

const TECDropdown = {
    init() {
        $( document ).on( 'click', '.tec-dropdown__title', function() {
            $( this ).parent().toggleClass( 'tec-dropdown--active' );
        });

        $( document ).on( 'change', '.tec-dropdown [type="checkbox"]', function() {
            let dropdown = $( this ).parents( '.tec-dropdown' );
            let vals = dropdown.find( 'input:checked' ).map(function() {
                return this.value;
            }).get().join(',');

            dropdown.find( '[type="hidden"]' ).val( vals );

            let catCount = dropdown.find( 'input:checked' ).length;
            let countText = catCount ? `(${catCount})` : '';
            dropdown.find('span').text( countText );
        } )

        $( document ).on( 'click', '.tec-dropdown__list-item.has-children', function(e) {
            if ( this !== e.target ) {
                return;
            }

            $( this ).toggleClass( 'show-children' );
        } )
    }
}

export default TECDropdown;